
<div class="mb-dialog">
  <mb-dialog-body class="dialog-body">
    <div class="dialog-body__icon--mobile">
      <mb-icon icon="peso"> </mb-icon>
    </div>

    <h3>El precio de tu habitación cambio.</h3>

    <img alt="" src="/hotels/dist/es-AR/browser/assets/images/rate-changed.svg" />

    <p *ngIf="dialogData.priceChanged; else samePrice">
      <strong
        >La tarifa que seleccionaste era de {{ dialogData.oldPrice | Currency: true }} y
        la nueva es {{ dialogData.newPrice | Currency: true }}.</strong
      >
      Podés hacer la reserva con este nuevo valor o volver a realizar la búsqueda
      nuevamente.
    </p>
    <ng-template #samePrice>
      <p>
        <strong>La tarifa que seleccionaste ya no está disponible.</strong><br />
        Podés hacer la reserva con este nuevo valor o buscar otra habitación disponible.
      </p>
    </ng-template>
  </mb-dialog-body>
  <mb-dialog-footer>
    <div *ngIf="dialogData.priceChanged; else samePriceBtn" class="buttons-container">
      <button
        mb-button
        variant="floating"
        color="secondary"
        (click)="closeDialog(closeEvents.CLOSE_DIALOG)"
      >
        Quiero otra opción
      </button>
      <button
        mb-button
        color="secondary"
        (click)="closeDialog(closeEvents.CONFIRM_RESERVATION)"
      >
        COMPRAR
      </button>
    </div>
    <ng-template #samePriceBtn>
      <button
        mb-button
        color="secondary"
        (click)="closeDialog(closeEvents.REFRESH_PRICE)"
      >
        Actualizar precio
      </button>
    </ng-template>
  </mb-dialog-footer>
</div>
